import React, {useState} from 'react';

import {Button, ButtonVariant, DefaultErrorOverlay, Text, ZIndex} from '@ael/shared-components-library';
import classNames from 'classnames';

type ErrorOverlayProps = {
  error: Error;
  resetErrorBoundary: () => void;
};

export const UnhandledError = (props: ErrorOverlayProps) => {
  const [showDetails, setShowDetails] = useState(false);

  return (
    <ZIndex index={9999}>
      <DefaultErrorOverlay
        title="Something went wrong"
        description={
          <>
            <p>It’s not you, it’s us! We have detected an error when communicating with server.</p>
            <p> Reload the page to see, if the problem persists.</p>
          </>
        }
      >
        <div className={classNames('flex gap-3')}>
          <Button variant={ButtonVariant.DANGER} onClick={props.resetErrorBoundary}>
            {/*type to be changed, after Marios feature*/}
            Reload
          </Button>

          <Button variant={ButtonVariant.BLUE} onClick={() => setShowDetails(!showDetails)}>
            {showDetails ? 'Hide details' : 'Show details'}
          </Button>
        </div>

        {showDetails && <UnhandledErrorDetails error={props.error} />}
      </DefaultErrorOverlay>
    </ZIndex>
  );
};

const UnhandledErrorDetails = (props: { error: Error }) => {
  return (
    <>
      <Text>Error name: {props.error.name}</Text>
      <Text>Error message: {props.error.message}</Text>
      <Text>Error stack trace:</Text>
      <Text>{props.error.stack}</Text>
    </>
  );
};
